import Box from "@mui/material/Box";
import { Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useId, useMemo } from "react";
import { useAppDispatch } from "../../../redux/store";
import { addModalOpened, removeModalOpened } from "../../../redux/features/appStateSlice";

export interface GenericModalProps {
  open: boolean;
  title: string;
  handleClose: any;
  children: any;
  style: {};
}

export default function GenericModal(props: GenericModalProps) {
  let { open, title, handleClose, children, style } = props;
  const dispatch = useAppDispatch();
  const modalId = useId();

  useEffect(() => {
    if (open) {
      dispatch(addModalOpened(modalId));
    } else {
      dispatch(removeModalOpened(modalId));
    }
  }, [open]);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "#007bff",
              boxShadow: "rgb(0, 0, 0) 0px 0px 10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              id="modal-title"
              variant="h4"
              sx={{ p: 2, color: "white" }}
            >
              {title}
            </Typography>
            <Button onClick={handleClose}>
              <CloseIcon sx={{ color: "white" }} />
            </Button>
          </Box>

          <Box sx={{ p: 5, overflow: "auto", maxHeight: "80vh" }}>
            {children}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
